module.exports = __webpack_public_path__ + "img/herobanner.d4f81093.jpg";